<template>
  <div class="module-card" :class="`${isSubmoduleActive ? 'active' : ''}`">
    <div class="module-card-title-container">
      <div class="title">{{ module.Name.value }}</div>
      <Checkbox :checked="isSubmoduleCompleted" />
    </div>
    <div class="module-card-description"></div>
    <div class="btn-primary " v-if="isSubmoduleActive">
      <span v-if="!isQuestionsVisible" @click.stop.prevent="onQuestionClick"
        >Prüfungsfragen</span
      >
      <span v-if="isQuestionsVisible">Prüfungsfragen</span>
    </div>
  </div>
</template>
<script setup>
import { defineProps, ref, defineEmits } from "vue";
import Checkbox from "@/components/Checkbox.vue";

const props = defineProps({
  module: Object,
  isSubmoduleActive: Boolean,
  isSubmoduleCompleted: Boolean,
  isQuestionsVisible: Boolean,
});
const emit = defineEmits([]);
const onQuestionClick = (e) => {
  emit("onQuestionClick", e);
};
</script>
<style lang="scss" scoped>
.module-card {
  box-sizing: border-box;
  height: 100%;
  background: $white;
  border: 1.5px solid $line;
  box-shadow: $btnShadow;
  border-radius: 14px;
  padding: 15px;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;
  &-title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 5px;
    .title {
      font-family: 'Poppins', 'ui-sans-serif', system-ui, sans-serif;
      font-weight: 600;
      font-size: 18px;
      line-height: 28px;
      color: $ink;
    }
  }
  &-description {
    font-weight: 400;
    font-size: 14px;
    line-height: 26px;
    color: $muted;
    padding-bottom: 20px;
  }
}
.module-card:hover {
  background: $primary-deep;
  border-color: $primary-deep;
  .module-card-title-container {
    .title {
      color: $white;
    }
  }
  .module-card-description {
    color: rgba(255, 255, 255, 0.75);
  }
}
.active {
  background: $primary-deep;
  border-color: $primary-deep;
  .module-card-title-container {
    .title {
      color: $white;
    }
  }
  .module-card-description {
    color: rgba(255, 255, 255, 0.75);
  }
}
</style>
